import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/anshika.css';
import './assets/css/sarwar.css';
import './assets/css/responsive.css';
import './assets/css/sudeep.css'

import { GoogleOAuthProvider } from '@react-oauth/google';
import MasterProvider from 'provider/MasterProvider';
import MetaProvider from 'provider/MetaProvider';
import { AuthProvider } from 'provider/AuthContext';
import SafariPackagesProvider from 'provider/SharePackagesProvider';
import ParksProvider from 'provider/ParksProvider';
import { ToastProvider } from 'provider/ToastProvider';
import SharedSafariProvider from 'provider/ShareSafariProvider';
import ProfileProvider from 'provider/ProfileProvider';
import { ScreenSizeProvider } from 'provider/ScreenSizeProvider';
import OperatorProfileProvider from 'provider/OperatorProfileProvider';
import HomeProvider from 'provider/HomeProvider';
import ParksViewProvider from 'provider/ParkViewProvider';
import WishListProvider from 'provider/WishListProvider';
import AlertProvider from 'provider/AlertProvider';
import DrawerProvider from 'provider/DrawerProvider';
import MobileVerifyProvider from 'provider/MobileVerificationProvider';

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered:", registration);
//     })
//     .catch((err) => console.log("SW registration error:", err));
// }

const clientId = process.env.REACT_APP_GOOGLE_AUTH;  //walkintowild Web Application
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <MasterProvider>
        <MetaProvider>
          <ScreenSizeProvider>
            <AlertProvider>
              <HomeProvider>
                <DrawerProvider>
                  <MobileVerifyProvider>
                    <SharedSafariProvider>
                      <AuthProvider>
                        <ProfileProvider>
                          <OperatorProfileProvider>
                            <ToastProvider>
                              <SafariPackagesProvider>
                                <ParksProvider>
                                  <ParksViewProvider>
                                    <WishListProvider>
                                      <App />
                                    </WishListProvider>
                                  </ParksViewProvider>
                                </ParksProvider>
                              </SafariPackagesProvider>
                            </ToastProvider>
                          </OperatorProfileProvider>
                        </ProfileProvider>
                      </AuthProvider>
                    </SharedSafariProvider>
                  </MobileVerifyProvider>
                </DrawerProvider>
              </HomeProvider>
            </AlertProvider>
          </ScreenSizeProvider>
        </MetaProvider>
      </MasterProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();


// 106811897499435890403